import { type BadgeVariations } from '@synqo/frontend-component-library';

export const groupVariants: readonly BadgeVariations[] = [
    'accent',
    'info',
    'success',
    'warning',
    'primary',
    'danger',
    'default',
] as const;
const guidToVariantMap: Partial<Record<string, BadgeVariations>> = {};

export const getUserGroupVariant = (groupGuid: string): BadgeVariations => {
    if (!(groupGuid in guidToVariantMap)) {
        const knownGroupsAmount = Object.keys(guidToVariantMap).length;
        guidToVariantMap[groupGuid] =
            knownGroupsAmount >= groupVariants.length ? 'default' : groupVariants[knownGroupsAmount];
    }

    return guidToVariantMap[groupGuid] ?? 'default';
};
